import config from '../../../config'
import { authHeader, customFetch, handleResponse, commonRequestOptions } from '../../../helpers'
import { appName } from '../appConfig'

const base = `${appName}/clientContact`

export const clientContactService = {
  getByClient,
  create,
  update,
  remove,
}

function getByClient(clientSlug, signal) {
  const opts = { method: 'GET', headers: authHeader(), ...commonRequestOptions() }
  return customFetch(`${config.api.url}/${base}/by-client/${encodeURIComponent(clientSlug)}`, opts, signal).then(handleResponse)
}

function create(payload, signal) {
  const opts = {
    method:  'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body:    JSON.stringify(payload),
    ...commonRequestOptions(),
  }
  return customFetch(`${config.api.url}/${base}`, opts, signal).then(handleResponse)
}

// id is client_contact_id (integer) — client_contact has no uuid column.
function update(id, payload, signal) {
  const opts = {
    method:  'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body:    JSON.stringify(payload),
    ...commonRequestOptions(),
  }
  return customFetch(`${config.api.url}/${base}/${id}`, opts, signal).then(handleResponse)
}

function remove(id, signal) {
  const opts = {
    method:  'DELETE',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body:    JSON.stringify({}),
    ...commonRequestOptions(),
  }
  return customFetch(`${config.api.url}/${base}/${id}`, opts, signal).then(handleResponse)
}
